import React, { useState } from 'react';
import { airtableService } from '../services/airtable';

const TestConnection = () => {
  const [testResults, setTestResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const addResult = (test, result, details = '') => {
    setTestResults(prev => [...prev, { 
      test, 
      result, 
      details,
      timestamp: new Date().toLocaleTimeString() 
    }]);
  };

  const runTests = async () => {
    setLoading(true);
    setTestResults([]);

    // Test 1: Check environment variables
    addResult(
      'Environment Variables',
      process.env.REACT_APP_AIRTABLE_API_KEY ? 'PASS' : 'FAIL',
      `API Key: ${process.env.REACT_APP_AIRTABLE_API_KEY ? 'Found' : 'Not found'}, Base ID: ${process.env.REACT_APP_AIRTABLE_BASE_ID ? 'Found' : 'Not found'}`
    );

    // Test 2: Airtable service initialization
    const configLoaded = airtableService.loadSavedConfig();
    addResult(
      'Airtable Initialization',
      configLoaded ? 'PASS' : 'FAIL',
      `Service initialized: ${airtableService.isInitialized}`
    );

    if (airtableService.isInitialized) {
      // Test 3: Table setup
      try {
        const tablesSetup = await airtableService.setupTablesIfNeeded();
        addResult(
          'Table Setup',
          tablesSetup ? 'PASS' : 'FAIL',
          'Attempting to create/verify tables'
        );
      } catch (error) {
        addResult('Table Setup', 'FAIL', error.message);
      }

      // Test 4: Test session creation
      try {
        const testSessionData = {
          sessionId: `test_${Date.now()}`,
          doctorName: 'Test Doctor',
          accessCode: '1234',
          clinicCode: 'TEST',
          startTime: new Date().toISOString()
        };

        const sessionResult = await airtableService.createSession(testSessionData);
        addResult(
          'Session Creation',
          sessionResult ? 'PASS' : 'FAIL',
          sessionResult ? `Session ID: ${sessionResult.id}` : 'Failed to create test session'
        );

        // Clean up test session
        if (sessionResult) {
          await airtableService.endSession(testSessionData.sessionId, new Date().toISOString());
          addResult('Session Cleanup', 'PASS', 'Test session cleaned up');
        }
      } catch (error) {
        addResult('Session Creation', 'FAIL', error.message);
      }
    }

    setLoading(false);
  };

  return (
    <div className="container">
      <div className="header">
        <h1>Connection Test</h1>
        <p>Debug Airtable connection and setup</p>
      </div>
      
      <div className="card">
        <button 
          onClick={runTests}
          className="btn btn-primary"
          disabled={loading}
          style={{ marginBottom: '20px' }}
        >
          {loading ? 'Running Tests...' : 'Run Connection Tests'}
        </button>

        {testResults.length > 0 && (
          <div>
            <h3>Test Results:</h3>
            {testResults.map((result, index) => (
              <div 
                key={index}
                style={{
                  padding: '12px',
                  marginBottom: '8px',
                  backgroundColor: result.result === 'PASS' ? '#e8f5e8' : '#ffe6e6',
                  borderRadius: '6px',
                  border: `2px solid ${result.result === 'PASS' ? 'var(--muted-sage)' : 'var(--coral)'}`
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <strong>{result.test}</strong>
                  <span style={{ 
                    color: result.result === 'PASS' ? 'var(--muted-sage)' : 'var(--coral)',
                    fontWeight: 'bold'
                  }}>
                    {result.result}
                  </span>
                </div>
                {result.details && (
                  <div style={{ fontSize: '14px', color: 'var(--text-light)', marginTop: '4px' }}>
                    {result.details}
                  </div>
                )}
                <div style={{ fontSize: '12px', color: 'var(--text-light)' }}>
                  {result.timestamp}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="card">
        <h3>Debug Info</h3>
        <div style={{ fontSize: '14px', fontFamily: 'monospace' }}>
          <div>Current URL: {window.location.href}</div>
          <div>Environment: {process.env.NODE_ENV}</div>
          <div>Airtable Initialized: {String(airtableService.isInitialized)}</div>
          <div>Local Storage Config: {localStorage.getItem('airtable_config') ? 'Found' : 'Not found'}</div>
        </div>
      </div>
    </div>
  );
};

export default TestConnection;